export default function Datenschutz() {
  return (
    <div data-testid="page-datenschutz">
      <section className="border-b border-[#E3DECE]">
        <div className="max-w-3xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#BA6D52]">Rechtliches</p>
          <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl font-light tracking-tighter mt-6">Datenschutz</h1>
        </div>
      </section>

      <section>
        <div className="max-w-3xl mx-auto px-6 md:px-12 py-20 md:py-28 space-y-12 text-[#2C2A26]">
          <div>
            <h2 className="font-serif text-2xl font-medium">1. Verantwortlicher</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Verantwortlich für die Datenverarbeitung im Zusammenhang mit dieser Website und allen
              darüber angebotenen Leistungen (Mietkoch, Privatkoch, Koch-Vermittlung) ist
              Lukas Stutz, Schloßstraße&nbsp;32, 64720&nbsp;Michelstadt, Deutschland,
              mietkoch@stutz-cuisine.com. Ein Datenschutzbeauftragter ist gesetzlich nicht
              erforderlich und wurde nicht bestellt.
            </p>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Diese Erklärung gilt für alle drei Leistungsbereiche. Die Abschnitte&nbsp;4a
              (Privatkoch) und&nbsp;4b (Vermittlung) enthalten zusätzliche, bereichsspezifische
              Angaben.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">2. Erhebung und Verarbeitung personenbezogener Daten</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Personenbezogene Daten werden ausschliesslich dann erhoben, wenn Sie
              diese im Rahmen einer Anfrage (z.&nbsp;B. über das Anfrageformular) oder
              über andere Kontaktwege freiwillig mitteilen. Verarbeitet werden
              insbesondere: Name, Betrieb, Anschrift/Ort, Telefonnummer, E-Mail-Adresse
              sowie Angaben zum gewünschten Einsatz (Datum, Dauer, Bereich).
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">3. Zweck der Verarbeitung</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Die Verarbeitung dient der Beantwortung Ihrer Anfrage, der Vorbereitung
              und Durchführung eines Einsatzes sowie der Abwicklung vertraglicher
              Pflichten (Rechnung, Auftragsbestätigung, Stundenabrechnung). Rechtsgrundlage
              ist Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung und -durchführung).
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">4. Newsletter &amp; Werbe-E-Mails (freiwillig)</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Zusätzlich zu geschäftlichen E-Mails können Sie im Anfrageformular
              optional der Zusendung gelegentlicher Neuigkeiten und Angebote per E-Mail
              zustimmen. Die Anmeldung erfolgt im <b>Double-Opt-In-Verfahren</b>: Nach
              Absenden der Anfrage erhalten Sie eine Bestätigungs-E-Mail mit einem
              Aktivierungslink. Erst nach dem Klick auf diesen Link werden Sie in den
              Verteiler aufgenommen. Rechtsgrundlage ist Ihre ausdrückliche Einwilligung
              (Art. 6 Abs. 1 lit. a DSGVO i.&nbsp;V.&nbsp;m. § 7 Abs. 2 Nr. 3 UWG).
            </p>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Sie können Ihre Einwilligung jederzeit widerrufen — entweder über den
              Abmelde-Link am Ende jeder Werbe-E-Mail oder per formloser Nachricht
              an <a href="mailto:mietkoch@stutz-cuisine.com" className="text-[#BA6D52] underline">mietkoch@stutz-cuisine.com</a>.
              Der Widerruf hat keine Auswirkung auf die geschäftliche Kommunikation
              zu bereits erteilten Aufträgen (Bestätigungen, Rechnungen etc.).
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">4a. Privatkoch-Anfragen (Verbraucher)</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Bei Anfragen für Privatkoch-Leistungen verarbeite ich Ihre Kontaktdaten, die
              Veranstaltungsadresse, Datum und Personenzahl sowie Ihre Angaben zu Menüwünschen.
              Rechtsgrundlage ist Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;b DSGVO (Vertragsanbahnung und
              -erfüllung).
            </p>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Angaben zu <b>Allergien, Unverträglichkeiten und Ernährungsformen</b> können
              Gesundheitsdaten im Sinne des Art.&nbsp;9 DSGVO darstellen. Diese verarbeite ich
              ausschließlich auf Grundlage Ihrer <b>ausdrücklichen Einwilligung</b>
              (Art.&nbsp;9 Abs.&nbsp;2 lit.&nbsp;a DSGVO), die Sie durch die freiwillige Angabe
              erteilen, und nur zum Zweck der sicheren Zubereitung Ihres Menüs. Sie können diese
              Einwilligung jederzeit widerrufen; in diesem Fall kann eine auf Ihre Bedürfnisse
              abgestimmte Zubereitung nicht mehr gewährleistet werden. Diese Angaben werden
              spätestens <b>3&nbsp;Monate nach dem Einsatz</b> gelöscht und nicht an Dritte
              weitergegeben.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">4b. Koch-Vermittlung</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              <b className="text-[#2C2A26]">Registrierung als Mietkoch.</b> Bei der Registrierung
              verarbeite ich Ihre Stamm- und Kontaktdaten, Ihr berufliches Profil (Einsatzgebiet,
              Bereiche, Positionen, Erfahrung, Preisvorstellungen, Verfügbarkeit) sowie die von
              Ihnen hochgeladenen Unterlagen: bei Wohnsitz in Deutschland
              <b> Gewerbeanmeldung, Lebenslauf und Belehrung nach §&nbsp;43&nbsp;IfSG</b>, bei Wohnsitz
              in Österreich <b>Gewerbeschein, Lebenslauf und Nachweis der Lebensmittelhygiene-Schulung
              nach LMSVG</b>. Rechtsgrundlage ist Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;b DSGVO
              (Durchführung des Vermittlungsvertrags), für die freiwilligen Zusatzangaben
              Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;a DSGVO.
            </p>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Der Hygienenachweis (Belehrung nach §&nbsp;43&nbsp;IfSG bzw. LMSVG-Schulung) kann einen
              Gesundheitsbezug aufweisen. Sie wird
              ausschließlich zum Nachweis der lebensmittelrechtlichen Voraussetzungen und nur auf
              Grundlage Ihrer ausdrücklichen Einwilligung verarbeitet
              (Art.&nbsp;9 Abs.&nbsp;2 lit.&nbsp;a DSGVO). Inhalte Ihrer Unterlagen werden nicht
              ausgewertet, die Dokumente lediglich auf Vollständigkeit geprüft.
            </p>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              <b className="text-[#2C2A26]">Digitale Unterschrift.</b> Unterschreiben Sie den
              Vermittlungsvertrag online, werden zusätzlich Ihr Namenszug als Bilddatei, der
              Zeitstempel der Unterzeichnung und eine Dokumentenkennung gespeichert. Diese Daten
              dienen ausschließlich dem Nachweis der Vertragserklärung
              (Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;b und lit.&nbsp;f DSGVO).
            </p>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              <b className="text-[#2C2A26]">Speicherung und Löschung.</b> Dokumente werden
              verschlüsselt bei einem Auftragsverarbeiter innerhalb der EU gespeichert und sind
              ausschließlich für mich zugänglich. Sie werden gelöscht, wenn Sie Ihre Registrierung
              widerrufen oder die Zusammenarbeit endet — spätestens <b>24&nbsp;Monate nach dem
              letzten Einsatz</b>, sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
              Bei einer Ablehnung Ihrer Registrierung werden die Unterlagen innerhalb von
              <b>&nbsp;3&nbsp;Monaten</b> gelöscht. Sie können die Löschung jederzeit per E-Mail
              an mietkoch@stutz-cuisine.com verlangen.
            </p>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              <b className="text-[#2C2A26]">Betriebsanfragen.</b> Bei Anfragen von Betrieben
              verarbeite ich Firmen- und Ansprechpartnerdaten, Einsatzdaten bzw. Stellenangaben
              sowie Ihre Angaben zum Budget. Rechtsgrundlage ist Art.&nbsp;6 Abs.&nbsp;1
              lit.&nbsp;b DSGVO. Bei Betrieben mit Sitz in Österreich verarbeite ich zusätzlich die
              <b> UID-Nummer</b>. Diese wird zur Prüfung der Voraussetzungen für eine
              Reverse-Charge-Rechnung an das <b>Umsatzsteuer-Informationsaustauschsystem (VIES)</b> der
              Europäischen Kommission übermittelt; gespeichert werden das Prüfergebnis, der Zeitpunkt
              und die Bestätigungsnummer. Rechtsgrundlage ist Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;c DSGVO
              (steuerliche Pflichten) i.&nbsp;V.&nbsp;m. Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;b DSGVO.
            </p>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              <b className="text-[#2C2A26]">Einsätze in Deutschland und Österreich.</b> Die Vermittlung
              erfolgt in beiden Ländern und auch grenzüberschreitend. Ihre Daten werden dabei
              ausschließlich innerhalb der EU verarbeitet; eine Übermittlung in ein Drittland findet
              nicht statt. Bei einem grenzüberschreitenden Einsatz kann die Weitergabe von Angaben
              zur Entsendung (z.&nbsp;B. A1-Bescheinigung) an den Auftraggeber erforderlich sein —
              dies erfolgt nur nach vorheriger Abstimmung mit Ihnen.
            </p>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              <b className="text-[#2C2A26]">Keine automatisierte Entscheidung.</b> Eine
              Vermittlungsentscheidung erfolgt stets durch mich persönlich. Ein automatisiertes
              Profiling oder eine automatisierte Einzelfallentscheidung im Sinne des
              Art.&nbsp;22 DSGVO findet nicht statt.
            </p>
          </div>


          <div>
            <h2 className="font-serif text-2xl font-medium">5. Weitergabe an Dritte und Auftragsverarbeiter</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Eine Weitergabe Ihrer Daten erfolgt nur, soweit dies für die Vertragsabwicklung
              erforderlich ist, Sie zugestimmt haben oder eine gesetzliche Pflicht besteht.
              Eingesetzte Dienstleister (Auftragsverarbeiter nach Art.&nbsp;28&nbsp;DSGVO):
            </p>
            <ul className="mt-4 space-y-2 text-[#757067] font-light leading-relaxed">
              <li>— <b className="text-[#2C2A26]">Resend, Inc.</b> — Versand von
                Benachrichtigungs-, Angebots- und Rechnungs-E-Mails</li>
              <li>— <b className="text-[#2C2A26]">Hosting- und Speicherdienstleister</b> — Betrieb
                der Website sowie verschlüsselte Ablage hochgeladener Dokumente</li>
              <li>— <b className="text-[#2C2A26]">Lexware / LexOffice</b> — Erstellung und
                Archivierung von Rechnungen im Rahmen der steuerlichen Pflichten</li>
              <li>— <b className="text-[#2C2A26]">Steuerberatung</b> — im Rahmen der gesetzlichen
                Buchführungs- und Aufbewahrungspflichten</li>
              <li>— <b className="text-[#2C2A26]">Europäische Kommission (VIES)</b> — Prüfung der
                UID-Nummer von Betrieben aus Österreich; übermittelt werden ausschließlich Länderkennung
                und UID-Nummer</li>
            </ul>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Im Rahmen der Koch-Vermittlung werden Profildaten und Unterlagen eines Kochs
              ausschließlich <b>nach vorheriger Abstimmung mit dem betroffenen Koch</b> an einen
              konkreten Auftraggeber weitergegeben. Umgekehrt werden Daten eines Auftraggebers nur
              an den Koch weitergegeben, der für den Einsatz vorgesehen ist.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">6. Speicherdauer</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Ihre Daten werden nur so lange gespeichert, wie es für die genannten Zwecke
              erforderlich ist oder gesetzliche Aufbewahrungspflichten dies vorschreiben.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">7. Ihre Rechte</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung
              der Verarbeitung sowie Widerspruch. Wenden Sie sich hierzu bitte an die
              im Impressum genannten Kontaktdaten.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">8. Reichweitenmessung</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Diese Website nutzt eine minimale, serverseitige Reichweitenmessung: Beim Aufruf einer
              Seite werden ausschließlich der aufgerufene Pfad, der Referrer (verweisende Seite) und
              ein täglich rotierender Hash aus IP-Adresse und Browser-Kennung gespeichert. Die
              IP-Adresse selbst wird <b>zu keinem Zeitpunkt gespeichert</b>. Es kommen weder Cookies
              noch externe Tracking-Dienste (z. B. Google Analytics) zum Einsatz. Eine Identifizierung
              einzelner Personen ist nicht möglich. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO
              (berechtigtes Interesse an anonymer Reichweitenanalyse zur Verbesserung des Angebots).
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">9. SSL-Verschlüsselung</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Diese Website verwendet eine SSL-Verschlüsselung zum Schutz der Übertragung
              vertraulicher Inhalte, z.&nbsp;B. der Anfragen, die Sie an mich senden.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">10. Aktualität</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Diese Datenschutzerklärung ist aktuell gültig. Bei Änderungen der Website
              oder gesetzlicher Vorgaben kann eine Anpassung erforderlich werden.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
